const InventoryPolicy = {
  Continue: 'continue',
  Deny: 'deny',
};

export default InventoryPolicy;
